import React, { useState, useEffect } from "react";

import ViewChartItemForModal from "./ViewChartItemForModal";
import { CA_GEO_HIERARCHY_ELEMENTS, CA_RECOMMENDATION_ELEMENTS, CHART_ITEMS } from "../constants";
import { getEnityNameForCAband } from "../utils";

const ViewChartSectionForModal = ({
    getSmartChartMasterFilterDropDown,
    projectsDropdownData = [],
    projectId,
    currentBand,
    currentBandIndex,
    masterFilterList,
    openChartItemConfigModal,
    chartSectionData,
    entity,
    toggleImageListForBandModal,
    isExcelExport,
    openFilterModal,
    editImageBand,
    openExecutiveSummaryHierarchyConfig,
    isSouceTemplate = false,
    ...props
}) => {
    const [chartData, setChartData] = useState([]);

    useEffect(() => {
        setChartItemData(entity);
    }, [chartSectionData]);

    const setChartItemData = (entity = "project") => {
        let chartDataArray = [];
        let chartItemList = { ...chartSectionData.type };
        let chartKeys = Object.keys(chartItemList);
        let entityKeys = Object.keys(CHART_ITEMS[entity]);
        chartKeys.forEach(chartItem => {
            const tile = chartItemList?.[chartItem] || {};
            const isExecSumHierarchy = !!tile?.is_building_exec_sum;
            const isExecSumParent = !!tile?.exec_sum_parent_wrapper;
            const execSumBandValues = (() => {
                const b = tile.band;
                if (!b) return [];
                return Array.isArray(b) ? b : Object.values(b);
            })();
            const flatChild = isExecSumHierarchy && !isExecSumParent && execSumBandValues?.length === 1 ? execSumBandValues[0] : null;
            const isExecSumFlatImage = flatChild?.band_type === "image";
            const isExecSumFlatText = flatChild?.band_type === "text";
            let filter = false;
            const band1ConfigFilter = chartItemList[chartItem]?.band1;
            const ConfigFilterNames = chartItemList[chartItem];
            if (
                (band1ConfigFilter?.config_filter && Object.keys(band1ConfigFilter?.config_filter).length > 0) ||
                (ConfigFilterNames?.config_filter && Object.keys(ConfigFilterNames?.config_filter).length > 0)
            ) {
                filter = Object.entries(band1ConfigFilter?.config_filter || ConfigFilterNames?.config_filter)
                    .map(([key, value]) =>
                        (key === "global_search" && value) ||
                        (key === "wildcard_filters" && Object.keys(value).length > 0) ||
                        (key === "surveyor" && value) ||
                        (key === "image_or_not" && value) ||
                        (key === "infrastructure_request" && value) ||
                        (key === "water" && value) ||
                        (key === "energy" && value) ||
                        (key === "fmp" && value) ||
                        (key === "facility_master_plan" && value) ||
                        (key === "recommendation_type" && value) ||
                        (key === "budget_priority" && value)
                            ? true
                            : false
                    )
                    .reduce((acc, count) => acc + count, 0);
                if (ConfigFilterNames?.config_filter_names?.list || band1ConfigFilter?.config_filter_names?.list) {
                    filter = true;
                }
            }
            if (
                (ConfigFilterNames?.config_filter_names?.CA_BandFilter &&
                    Object.values(ConfigFilterNames?.config_filter_names?.CA_BandFilter)?.some(arr => Array.isArray(arr) && arr.length > 0)) ||
                (band1ConfigFilter?.config_filter_names?.CA_BandFilter &&
                    Object.values(band1ConfigFilter?.config_filter_names?.CA_BandFilter)?.some(arr => Array.isArray(arr) && arr.length > 0))
            ) {
                filter = true;
            }
            chartDataArray.push({
                name:
                    chartItem.includes("user_doc") || chartItem.includes("image_doc")
                        ? chartItemList[chartItem]?.name || chartItem
                        : chartItem.includes("list_image")
                        ? chartItemList[chartItem]?.name || "Image Band"
                        : chartItem.includes("normal_recom")
                        ? chartItemList[chartItem]?.band1?.name || "Recommendation Table"
                        : chartItem.includes("recom_onepager")
                        ? chartItemList[chartItem]?.band1?.name || "Recommendation One Pager"
                        : chartItem.includes("asset-onepager")
                        ? chartItemList[chartItem]?.band1?.name || "Asset One Pager"
                        : chartItem.includes("multi_recommendation")
                        ? chartItemList[chartItem]?.name || "Recommendation Summary"
                        : chartItem.includes("building_report")
                        ? chartItemList[chartItem]?.band1?.name || "BBI/Stoplight Chart"
                        : chartItem.includes("addition_report")
                        ? chartItemList[chartItem]?.band1?.name || "BAI/Stoplight Chart"
                        : chartItem.includes("site_report")
                        ? chartItemList[chartItem]?.band1?.name || "BSI/Stoplight Chart"
                        : chartItem.includes("memo_field")
                        ? chartItemList[chartItem]?.name || "Text Band"
                        : chartItem.includes("filter_report1")
                        ? chartItemList[chartItem]?.name || "Master Filters"
                        : chartItem.includes("table_of_contents")
                        ? chartItemList[chartItem]?.name || "Table of Contents"
                        : chartItem.includes("multisystem_")
                        ? chartItemList[chartItem]?.name || "System"
                        : chartItem.includes("sorted_recom")
                        ? chartItemList[chartItem]?.band1?.name || "Sorted Recommendation"
                        : !entityKeys.includes(chartItem) && !isExecSumHierarchy
                        ? getComparativeAnalysisBandName(chartItem, chartItemList) || chartItem
                        : isExecSumHierarchy
                        ? tile?.name || flatChild?.name ||""
                        : chartItem,
                totalChartCount: chartItem.includes("list_image")
                    ? chartItemList?.[chartItem]?.data?.length || 0
                    : isExecSumFlatImage
                    ? flatChild?.data?.length || 0
                    :chartItem.includes("multi_recommendation")
                    ? chartItemList?.[chartItem]?.recommendations?.length || chartItemList?.[chartItem]?.number_of_recom || 0
                    : chartItem.includes("normal_recom") || chartItem.includes("recom_onepager") || chartItem.includes("asset-onepager")
                    ? chartItem.includes("asset-onepager")
                        ? chartItemList?.[chartItem]?.band1?.mfilter?.asset_ids?.length || 0
                        : chartItemList?.[chartItem]?.band1?.mfilter?.recommendations?.length ||
                          chartItemList?.[chartItem]?.band1?.number_of_recom ||
                          0
                    : (chartItemList?.[chartItem]?.summary_view?.chart_type?.length || 0) +
                      (chartItemList?.[chartItem]?.detailed_view?.chart_type?.length || 0),
                isUserDoc: chartItem.includes("user_doc") || chartItem.includes("image_doc") ? true : false,
                docKey: chartItem,
                isImage: chartItem.includes("image_doc") ? true : false,
                isImageBand: chartItem.includes("list_image") || isExecSumFlatImage,
                hasConfig:
                    CHART_ITEMS[entity]?.[chartItem.includes("multisystem_") ? "system" : chartItem]?.hasConfig ||
                    chartItem.includes("list_image") ||
                    chartItem.includes("building_report") ||
                    chartItem.includes("addition_report") ||
                    chartItem.includes("site_report") ||
                    chartItem.includes("multi_recommendation") ||
                    chartItem.includes("normal_recom") ||
                    chartItem.includes("recom_onepager") ||
                    chartItem.includes("asset-onepager") ||
                    (isExecSumHierarchy && (isExecSumParent || isExecSumFlatImage))
                        ? true
                        : false,
                config:
                    CHART_ITEMS[entity]?.[
                        chartItem.includes("multisystem_") ? "system" : chartItem.includes("building_report") ? "building_report1" : chartItem
                    ]?.config || null,
                entityIcon: isExecSumParent
                    ? "smart-chart-exec-sum-folder.svg"
                    : isExecSumFlatText
                      ? "clipboard-text.svg"
                      : getEntityIcon(
                            chartItem.includes("multisystem_") ? "system" : chartItem.includes("building_report") ? "building_report1" : chartItem,
                            entityKeys
                        ),
                isIndividualBuilding:
                    chartItemList?.[
                        chartItem.includes("multisystem_") ? "system" : chartItem.includes("building_report") ? "building_report1" : chartItem
                    ]?.hasOwnProperty("is_indv_bld"),
                isFilterReport: chartItem.includes("filter_report") ? true : false,
                isMemo: chartItem.includes("memo_field") || isExecSumFlatText,
                isExecutiveSummaryParent: isExecSumParent,
                innerHierarchyNodeId: flatChild?.band_id ?? null,
                flatBandData: flatChild || null,
                isBbi: chartItem.includes("building_report"),
                isBai: chartItem.includes("addition_report"),
                isBsi: chartItem.includes("site_report"),
                isCAband:
                    !chartItem.includes("list_image") &&
                    !chartItem.includes("image_doc") &&
                    !chartItem.includes("user_doc") &&
                    !chartItem.includes("multi_recommendation") &&
                    !chartItem.includes("normal_recom") &&
                    !chartItem.includes("recom_onepager") &&
                    !chartItem.includes("asset-onepager") &&
                    !chartItem.includes("memo_field") &&
                    !chartItem.includes("building_report") &&
                    !chartItem.includes("addition_report") &&
                    !chartItem.includes("site_report") &&
                    !chartItem.includes("multisystem_") &&
                    !isExecSumHierarchy &&
                    !entityKeys.includes(chartItem),
                filter: filter,
                tileData: chartItemList?.[chartItem],
                isMultipleRecommendation: chartItem.includes("multi_recommendation") ? true : false,
                isRecommendation: chartItem.includes("normal_recom") ? true : false,
                isOnePager: chartItem.includes("recom_onepager") || chartItem.includes("asset-onepager") ? true : false,
                isAssetOnePager: chartItem?.includes("asset-onepager"),
                tileData: chartItemList?.[chartItem],
                // isAsset: chartItem.includes("asset_band"),
                isTOC: chartItem.includes("table_of_contents"),
                isSortedRecom: chartItem.includes("sorted_recom"),
                isDynamicSystem: chartItem.includes("multisystem_"),
                isDynamicBBI: chartItem.startsWith("building_report") && chartItem !== "building_report1",
                isDynamicBSI: chartItem.startsWith("site_report") && chartItem !== "site_report1",
                isDynamicBAI: chartItem.startsWith("addition_report") && chartItem !== "addition_report1",
                hasPageBreak: chartItem === "energy_band" || chartItem.includes("list_image") || isExecSumFlatImage
            });
        });
        setChartData([...chartDataArray]);
    };

    const getEntityIcon = (chartItem, entityKeys = []) => {
        if (chartItem.includes("user_doc")) {
            return "file-type-standard.svg";
        }
        if (chartItem.includes("image_doc") || chartItem.includes("list_image")) {
            return "smart-chart-image-item.svg";
        }
        if (chartItem?.includes("recom_onepager")) {
            return "sm-charts-one-pager.svg";
        }
        if (
            chartItem === "sorted_recom" ||
            chartItem === "energy_band" ||
            chartItem === "water_band" ||
            chartItem === "multi_recommendation" ||
            chartItem === "normal_recom" ||
            chartItem === "asset_band" ||
            chartItem.includes("building_report") ||
            chartItem.includes("addition_report") ||
            chartItem.includes("site_report") ||
            chartItem.includes("filter_report1") ||
            !entityKeys.includes(chartItem) ||
            isExcelExport
        ) {
            return "sm-charts-table-blue-icon.svg";
        }
        return "smart-chart-chart-icon-item.svg";
    };
    const getComparativeAnalysisBandName = (chartItem = "") => {
        if (!chartItem) return "";

        const elements = [...CA_RECOMMENDATION_ELEMENTS, ...CA_GEO_HIERARCHY_ELEMENTS];
        const labelMap = Object.fromEntries(elements.map(({ key, label }) => [key, label]));

        const rawParts = chartItem?.split("_");
        const parts = [];
        for (let i = 0; i < rawParts.length; i++) {
            if (rawParts[i] === "fci" && rawParts[i + 1] === "benchmarking") {
                parts.push("fci_benchmarking");
                i++;
            } else {
                parts.push(rawParts[i]);
            }
        }

        parts.pop();
        const lastKey = parts.pop();

        const capitalize = w => w?.charAt(0)?.toUpperCase() + w?.slice(1);
        const getLabel = k => labelMap[k] || capitalize(k);

        const formatted = parts.map(getLabel);
        const lastLabel = getLabel(lastKey);

        if (lastLabel === "Breakdownyears") {
            return `Comparative Analysis Band (Cost by ${formatted.join(", ")} and Year Grouping)`;
        }
        return `Comparative Analysis Band (${formatted.join(", ")} & ${lastLabel})`;
    };
    return (
        <div class="drag-main">
            <div class="row m-0">
                <div class="col-md-12 p-0">
                    <div class="dragble-area">
                        {chartData.map((item, i) => (
                            <ViewChartItemForModal
                                index={i}
                                item={item}
                                currentBand={currentBand}
                                entity={entity}
                                openChartItemConfigModal={openChartItemConfigModal}
                                openFilterModal={openFilterModal}
                                toggleImageListForBandModal={toggleImageListForBandModal}
                                isExcelExport={isExcelExport}
                                editImageBand={editImageBand}
                                openExecutiveSummaryHierarchyConfig={openExecutiveSummaryHierarchyConfig}
                                isSouceTemplate={isSouceTemplate}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ViewChartSectionForModal;
